import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { InfiniteProgressBarComponent } from './infinite-progress-bar/infinite-progress-bar.component';
import { LoaderComponent } from 'app/main/components/loaders/loader/loader.component';
import { Loader2Component } from 'app/main/components/loaders/loader2/loader2.component';
import { BookingFormComponent } from './booking-form/booking-form.component';
import { CustomHeaderComponent } from './custom-header/custom-header.component';
import { SliderComponent } from './slider/slider.component';
import { CustomKeysPipe } from 'app/main/pipes/customKeysPipe.pipe';
import { SlugifyPipe } from 'app/main/pipes/slugify.pipe';
import { PaginationComponent } from './pager/pager.component';
import { LanguageSwitcherComponent } from './language-switcher/language-switcher.component';
import { FooterComponent } from './footer/footer.component';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { SnackbarComponent } from './snackbar/snackbar.component';
import { ListProductsComponent } from './list-products/list-products.component';
import { BackToListComponent } from './back-to-list/backtolist.component';
import { LightboxModule } from 'ngx-lightbox';

export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader{
	return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		RouterModule,
		LightboxModule,
		TranslateModule.forRoot({
			loader: {
				provide: TranslateLoader,
				useFactory: HttpLoaderFactory,
				deps: [HttpClient]
			},
			defaultLanguage: 'it',
		})
	],
	declarations: [
		BackToListComponent,
		InfiniteProgressBarComponent,
		LoaderComponent,
		Loader2Component,
		BookingFormComponent,
		CustomHeaderComponent,
		SliderComponent,
		PaginationComponent,
		FooterComponent,
		LanguageSwitcherComponent,
		ListProductsComponent,
		SnackbarComponent,
		CustomKeysPipe,
		SlugifyPipe,
	],
	exports: [
		CommonModule,
		BackToListComponent,
		InfiniteProgressBarComponent, 
		LoaderComponent,
		Loader2Component,
		BookingFormComponent,
		CustomHeaderComponent,
		SliderComponent,
		FooterComponent,
		PaginationComponent,
		LanguageSwitcherComponent,
		ListProductsComponent,
		SnackbarComponent,
		CustomKeysPipe,
		SlugifyPipe,
		FormsModule,
		ReactiveFormsModule,
		LightboxModule
	],
	providers: []
})
export class ComponentsModule { }
